import PropTypes from 'prop-types';
import React from 'react';
import styles from './styles.module.scss';

function TableList({ data, className }) {
  return (
    <div className={`${styles.content} ${className}`}>
      {data.map(({ label, value }, index) => {
        return (
          <div key={index} className={styles.row}>
            <div className={`${styles.col} B2`}>{label}</div>
            <div className={`${styles.col} B2 `}>{value}</div>
          </div>
        );
      })}
    </div>
  );
}

export default TableList;

TableList.propTypes = {
  className: PropTypes.any,
  data: PropTypes.any,
};
